"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Voucher = _interopRequireDefault(require("../../../components/Voucher"));
var _Voucher2 = _interopRequireDefault(require("./Voucher.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Voucher = function Voucher(_ref) {
  var lang = _ref.lang;
  var css = (0, _Voucher2.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.voucher, "mco-shop-checkout-voucher")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-shop-checkout__headline")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.checkout.voucher.headline",
    l: l
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Voucher.default, {
    lang: lang
  })));
};
var _default = Voucher;
exports.default = _default;